export enum AttachmentField {
    FILE_NAME = 'fileName',
    CREATED_BY = 'createdBy',
    CREATED = 'created',
    KIND = 'kind',
    SUBTYPE = 'subtype',
}
